<template>
<div class="events">
    <div class="row">
        <form :class="['events-search', 'col-xs-12', {'form-inline': !isMobile}]" @submit.prevent="changePage(1)">
            <hr class="hidden-xs">
            <div class="form-group">
                <div class="input-group">
                    <input type="search" v-model="filters.keywords" class="form-control" :placeholder="t.search_for_events">
                    <span class="input-group-btn">
                        <button class="btn btn-primary" type="submit"><i class="fa fa-search"></i></button>
                    </span>
                </div>
            </div>
            <div class="form-group" v-if="allowCommercial">
                <select v-model="filters.commercial" class="form-control" @change="changePage(1)">
                    <option value="">{{ t.commercial.any_party }}</option>
                    <option value="1">{{ t.commercial.commercial }}</option>
                    <option value="0">{{ t.commercial.non_commercial }}</option>
                </select>
            </div>
        </form>
        <div class="clearfix"></div>
        <div class="events-list">
            <div v-if="!loading && allEvents.length" class="col-md-3 col-sm-4" v-for="event in allEvents" :key="event.id">
                <eventCard :event="event"></eventCard>
            </div>
            <div v-if="!loading && !allEvents.length" class="alert alert-info text-center">
                <p>{{ t.no_events }}</p>
            </div>
        </div>
    </div>
    <loading v-if="loading"></loading>
    <pagination :page="page" :total="pages" @page-changed="changePage"></pagination>
</div>
</template>

<script>
import ajax from 'Site/js/util/ajax.fetch';
import Loading from 'Site/component/Loading.vue';
import Pagination from 'Site/component/Pagination.vue';
import { mapState } from 'vuex';
import EventCard from './EventCard.vue';

export default {
    name: 'Events',
    components: {
        EventCard,
        Loading,
        Pagination
    },
    computed: {
        ...mapState({
            allowCommercial: state => state.config.data.allowCommercial,
            isMobile: state => state.isMobile,
            routerConfig: state => state.config.data.router,
            t: state => state.t
        }),
        offset() {
            return (this.page * this.limit) - this.limit;
        },
        page() {
            return parseInt(this.$route.params.page, 10) || 1;
        }
    },
    data() {
        return {
            allEvents: this.events,
            filters: {
                commercial: '',
                keywords: ''
            },
            loading: false,
            limit: 12
        };
    },
    methods: {
        changePage(page) {
            // If page hasn't changed we have change a filter, call fetch explicitly
            if (page === this.page) {
                this.fetch();
            }
            this.$router.push({ path: `${this.routerConfig.page2Route}/${this.routerConfig.part.page}/${page}` });
        },
        fetch() {
            this.loading = true;
            ajax.get('event', {
                'start-index': this.offset,
                'max-results': this.limit,
                show: 'all',
                commercial: this.filters.commercial,
                keywords: this.filters.keywords
            }).then((response) => {
                this.allEvents = response.items;
                this.loading = false;
            });
        }
    },
    watch: {
        $route: 'fetch'
    },
    props: {
        events: {
            type: Array
        },
        pages: {
            type: Number
        }
    }
};

</script>

<style lang="scss">
@import "~Site/scss/variables";

.events-search {
    margin-bottom: 10px;
    input {
        margin: 0;
    }
}

@media (max-width: $screen-xs-max) {
    .events-list {
        margin-top: 10px;
    }
    .events {
        .col-md-3 {
            padding: 0;
        }
        .event-card .event-stats {
            padding: 9px !important;
        }
    }
}
</style>
